export default __webpack_public_path__ + "static/media/google-play-badge.c39ff0cc.svg";